export const medicType = [
  { value: "", label: "Select a Medic type" },
  { value: "doctor", label: "Doctors" },
  { value: "nurse", label: "Nurses" },
  { value: "midwife", label: "Midwife" },
  { value: "nurse/midwife", label: "Nurses/Midwife" },
];
